import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UtilityService } from './utility.service';
import { TimeOutPopupService } from '../ui-components/timeout-popup';

declare var timerObj: any;
declare var logoutCurrentUser: any;
declare var ENV_PORTAL: any;
declare var ENV_VAR: any;
declare var API_DOMAIN: any;

@Injectable()
export class HttpClientService {


  constructor(public http: HttpClient, private utilityService: UtilityService,
    private timeoutPopupService: TimeOutPopupService) {
  }

  tokenRefresh(url) {
    // url = url + '?random=' + this.utilityService.getRandom();
    console.log((new Error()).stack);
    this.authorizedGet(url, null, 'text')
      .pipe(
        map((res: HttpResponse<any>) => {
          let u = res.headers.get('iv-user');
          sessionStorage.setItem('iv-user', u);
          this.updateAuthorizationHeaders(res);
          return res.body;
        }))
      .subscribe((respobj: HttpResponse<any>) => {
        if (respobj.body !== null) {
          console.dir(respobj.body);
        }
      }, error => {
        if (error && error.status && error.status === 401) {

          logoutCurrentUser(true);
        }
        console.error(error);
      });
  }

  authorizedGet(url, headers?: HttpHeaders, responsetype?: any) {
    headers = this.setCommonHeaders(headers);
    headers = this.createAuthorizationHeader(headers);
    return this.http.get(url, {
      headers: headers,
      observe: "response",
      responseType: responsetype
    });
  }


  authorizedPost(url, data, headers?: HttpHeaders) {
    headers = this.setCommonHeaders(headers);
    headers = this.createAuthorizationHeader(headers);
    return this.http.post(url, data, {
      headers: headers,
      observe: "response"
    });
  }

  authorizedMultipartPost(url, data, headers?: HttpHeaders) {
    headers = this.setCommonHeaders(headers, true);
    headers = this.createAuthorizationHeader(headers);
    return this.http.post(url, data, {
      headers: headers,
      observe: "response"
    });
  }

  get(url, headers?: HttpHeaders) {
    let urlCheck = url.toString();
    headers = this.setCommonHeaders(headers);
    // let source = sessionStorage.getItem('SAPMP_ENV_PORTAL');
    return this.http.get(url, {
      headers: headers,
      observe: "response"
    });
  }
  // let test = "'arraybuffer'|'blob'|'json'|'text'";
  authorizedOctetget(url, headers?: HttpHeaders, responseType?: any) {
    headers = headers.append('Accept', 'application/octet-stream');
    headers = headers.append('Content-Type', 'application/json');
    headers = this.createAuthorizationHeader(headers);
    return this.http.get(url, {
      headers: headers,
      responseType: responseType,
      observe: "response"
    });
  }

  post(url, data, headers?: HttpHeaders) {
    headers = this.setCommonHeaders(headers);
    return this.http.post(url, data, {
      headers: headers,
      observe: "response"
    });
  }

  put(url, data, headers?: HttpHeaders) {
    headers = this.setCommonHeaders(headers);
    return this.http.put(url, data, {
      headers: headers,
      observe: "response"
    });
  }

  authorizedPut(url, data, headers?: HttpHeaders) {
    headers = this.setCommonHeaders(headers);
    headers = this.createAuthorizationHeader(headers);
    return this.http.put(url, data, {
      headers: headers,
      observe: "response"
    });
  }

  patch(url, data, headers?: HttpHeaders) {
    headers = this.setCommonHeaders(headers);
    return this.http.patch(url, data, {
      headers: headers,
      observe: "response"
    });
  }

  authorizedPatch(url, data, headers?: HttpHeaders) {
    headers = this.setCommonHeaders(headers);
    headers = this.createAuthorizationHeader(headers);
    return this.http.patch(url, data, {
      headers: headers,
      observe: "response"
    });
  }

  delete(url, data?: any, headers?: HttpHeaders) {
    headers = this.setCommonHeaders(headers);
    return this.http.delete(url, {
      headers: headers,
      observe: "response"
    });
  }

  authorizedDelete(url, data?: any, headers?: HttpHeaders) {
    headers = this.setCommonHeaders(headers);
    headers = this.createAuthorizationHeader(headers);
    return this.http.delete(url, {
      headers: headers,
      observe: "response"
    });
  }

  request(url, method: string, data?: any, headers?: HttpHeaders, ) {
    headers = this.setCommonHeaders(headers);
    return this.http.request(method, url, {
      headers: headers,
      body: data
    });
  }

  authorizedRequest(url, method: string, data?: any, headers?: HttpHeaders) {
    headers = this.setCommonHeaders(headers);
    headers = this.createAuthorizationHeader(headers);
    return this.http.request(method, url, {
      headers: headers,
      body: data
    });
  }

  updateAuthorizationHeaders(res: HttpResponse<any>) {
    if (res.headers.get('authorization') != null) {
      // keep premier session alive
      sessionStorage.setItem('sapmp_jwtToken', res.headers.get('authorization'));
    }
  }

  setCommonHeaders(headers?: HttpHeaders, isMultipart?: boolean) {
    if (!headers || headers === null) {
      headers = new HttpHeaders();
    }
    if (isMultipart) {
      // headers.append('Content-Type', 'multipart/form-data');
    } else {
      headers = headers.append('Content-Type', 'application/json');
    }
    headers = headers.append('Accept', 'text/html,application/json');
    // if (sessionStorage.getItem('sessionId') !== null && sessionStorage.getItem('sessionId') !== undefined && sessionStorage.getItem('sessionId') !== 'undefined') {
    //   headers = headers.append('X-ATT-UserSessionId', sessionStorage.getItem('sessionId'));
    // }
    // if (sessionStorage.getItem('attESSec') !== null) {
    //   headers = headers.append('X-ATT-attESSec', sessionStorage.getItem('attESSec'));
    //   headers = headers.append('X-ATT-attESHr', sessionStorage.getItem('attESHr'));
    // }
    headers = headers.append('source', ENV_PORTAL)
    return headers;
  }

  createAuthorizationHeader(headers: HttpHeaders = new HttpHeaders()) {
    if (sessionStorage.getItem('sapmp_jwtToken') != null) {
      this.timeoutPopupService.setTimeoutStatus(true);
      headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));

      headers = headers.append('channel', 'premier');
      headers = headers.append('portal', 'appmarket');
      var cookieItems: any = document.cookie;

    }
    return headers;
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  replaceTextInUrl(textToReplace, replaceWith, url) {
    if (url) {
      return url.replace(textToReplace, replaceWith);
    } else {
      return null;
    }
  }

  getProfile(url, headers?: HttpHeaders, params?: HttpParams) {
    headers = this.setCommonHeaders(headers);
    headers = this.createAuthorizationHeader(headers);
    return this.http.get(url, {
      headers: headers,
      observe: 'response',
      params: params
    });
  }

  getCurrentYear() {
    var d = new Date();
    return d.getFullYear();
  }

  handleError(error) {
    return throwError(error);
  }
}
